/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export var OptionalClaimsEnum;
(function (OptionalClaimsEnum) {
    OptionalClaimsEnum["FIRST_NAME"] = "firstName";
    OptionalClaimsEnum["LAST_NAME"] = "lastName";
})(OptionalClaimsEnum || (OptionalClaimsEnum = {}));
export class OptionalClaims {
}
OptionalClaims.FIRST_NAME = 'firstName';
OptionalClaims.LAST_NAME = 'lastName';
OptionalClaims.OPTIONAL_CLAIMS = [
    OptionalClaimsEnum.FIRST_NAME,
    OptionalClaimsEnum.LAST_NAME,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3B0aW9uYWwtY2xhaW1zLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc2hhcmVkL2F1dGhlbnRpY2F0aW9uL2NsYWltcy9vcHRpb25hbC1jbGFpbXMuZW51bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLGtCQUdYO0FBSEQsV0FBWSxrQkFBa0I7SUFDMUIsOENBQXdCLENBQUE7SUFDeEIsNENBQXNCLENBQUE7QUFDMUIsQ0FBQyxFQUhXLGtCQUFrQixLQUFsQixrQkFBa0IsUUFHN0I7QUFFRCxNQUFNLE9BQU8sY0FBYzs7QUFDQSx5QkFBVSxHQUFHLFdBQVcsQ0FBQztBQUN6Qix3QkFBUyxHQUFHLFVBQVUsQ0FBQztBQUV2Qiw4QkFBZSxHQUF5QjtJQUMzRCxrQkFBa0IsQ0FBQyxVQUFVO0lBQzdCLGtCQUFrQixDQUFDLFNBQVM7Q0FDL0IsQ0FBQSJ9